<template>
  <base-popup
      :popup-model="show"
      title="Generated links"
      :valid="!valid"
      :width="50"
      :show-save-button="false"
      :is-overlay="isOverlay"
      @onCancelButtonClick="closeFilesPopupHandler"
  >
    <div class="font-weight-bold mb-2 mt-2" v-if="currentItem.methods">
      Payment Information
    </div>
    <v-card v-if="currentItem.methods">
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <td>Payment Method</td>
              <td>{{ currentItem.methods ?  currentItem.methods.name : 'N/A'}}</td>
            </tr>
            <tr v-if="currentItem.payerId">
              <td>Paypal Payer ID</td>
              <td>{{currentItem.payerId}}</td>
            </tr>
            <tr v-if="currentItem.paymentId">
              <td>Paypal Payment ID</td>
              <td>{{currentItem.paymentId}}</td>
            </tr>
            <tr v-if="currentItem.refno">
              <td>2Checkout</td>
              <td>{{currentItem.refno}}</td>
            </tr>
            <tr v-if="currentItem.stripeId">
              <td>Stripe ID</td>
              <td>{{currentItem.stripeId}}</td>
            </tr>
            <tr v-if="currentItem.paddleId">
              <td>Checkout ID</td>
              <td>{{currentItem.paddleId}}</td>
            </tr>
            <tr v-if="currentItem.paddleId">
              <td>Order ID</td>
              <td>{{currentItem.paddleOrderId}}</td>
            </tr>
            <tr v-if="currentItem.trxnId">
              <td>Trxn ID</td>
              <td>{{currentItem.trxnId}}</td>
            </tr>
            <tr v-if="currentItem.phone">
              <td>Phone</td>
              <td>{{currentItem.phone}}</td>
            </tr>
            <tr v-if="currentItem.paymentDate">
              <td>Payment Date</td>
              <td>{{getDateTime(currentItem.paymentDate)}}</td>
            </tr>
            <tr v-if="currentItem.updater">
              <td>Last Updated By</td>
              <td>{{currentItem.updater.name}}</td>
            </tr>
            <tr class="mt-1" v-if="currentItem.attachment && !(currentItem.methods.normalizedName === 'usdt')">
              <td>Attachment:</td>
              <td>
                <template >
                  <a href="javascript:;">
                  <v-img
                      @click.stop.prevent="download(currentItem.attachment, `attachment-${currentItem.refcode}`)"
                      :src="currentItem.attachment" aspect-ratio="2"
                      contain
                      link
                  />
                  </a>
                </template>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <div class="font-weight-bold mb-2 mt-5">
      Live Links
    </div>
    <v-data-table
        :headers="headers"
        :items="details"
        hide-default-header
        hide-default-footer
        disable-pagination
        class="elevation-1 invoice-details"
    >
      <template v-slot:item.site="{item}">
        <v-chip color="primary" class="mt-1" v-if="item.site && item.site.site_url">
          {{item.site.site_url}}
        </v-chip>
        <v-chip color="primary" class="mt-1" v-else>
          {{item.customEntityName}}
        </v-chip>
        <v-simple-table dense v-if="currentItem.billingType === 'Link Insert'">
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                Anchor
              </th>
              <th class="text-left">
                URL
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="item.anchorText1">
              <td>{{item.anchorText1}}</td>
              <td>{{item.url1}}</td>
            </tr>
            <tr v-if="item.anchorText2">
              <td>{{item.anchorText2}}</td>
              <td>{{item.url2}}</td>
            </tr>
            <tr v-if="item.anchorText3">
              <td>{{item.anchorText3}}</td>
              <td>{{item.url4}}</td>
            </tr>
            <tr v-if="item.anchorText5">
              <td>{{item.anchorText5}}</td>
              <td>{{item.url5}}</td>
            </tr>
            <tr v-if="item.anchorText6">
              <td>{{item.anchorText6}}</td>
              <td>{{item.url6}}</td>
            </tr>
            <tr v-if="item.anchorText7">
              <td>{{item.anchorText7}}</td>
              <td>{{item.url7}}</td>
            </tr>
            <tr v-if="item.anchorText8">
              <td>{{item.anchorText8}}</td>
              <td>{{item.url8}}</td>
            </tr>
            <tr v-if="item.anchorText9">
              <td>{{item.anchorText9}}</td>
              <td>{{item.url9}}</td>
            </tr>
            <tr v-if="item.anchorText10">
              <td>{{item.anchorText10}}</td>
              <td>{{item.url10}}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        <br>
        <a @click.prevent.stop="liveLinkHandler(item.liveLink)" class="link-text">{{item.liveLink}}</a>
      </template>
      <template v-slot:item.total="{item}" class="column-vr-align">
        ${{item.total}}
      </template>
      <template v-slot:body.append>
        <tr>
          <td style="text-align: right"><h4>Sub Total</h4></td>
          <td style="text-align: right">${{currentItem.amount}} </td>
        </tr>
        <tr>
          <td style="text-align: right"><h4>Discount</h4></td>
          <td style="text-align: right">${{currentItem.discount}} </td>
        </tr>
        <tr>
          <td style="text-align: right"><h4>Grand Total</h4></td>
          <td style="text-align: right">${{currentItem.totalAmount}} </td>
        </tr>
      </template>
    </v-data-table>
    <div class="font-weight-bold mb-2 mt-5">
      Email Message
    </div>
    <v-spacer/>
    <v-card>
      <v-card-text id="myInput">
        <p>
          {{ getTitle(mailTemplate.title) }}<br><br>
          {{ mailTemplate.liveLinkText }}: {{getRefLink(currentItem.refcode)}}<br>
          <strong>{{ mailTemplate.stepTitle }}</strong><br><br>

          <span v-for="item in mailTemplate.steps" :key="item">{{item}}<br></span>
        </p>
      </v-card-text>
    </v-card>
    <div class="font-weight-bold mb-2 mt-5">
      Mail Information
    </div>
    <v-spacer/>
    <v-card>
      <v-card-text>
        <div><strong>Payment Mail:&nbsp;</strong>{{currentItem.paymentMail}} times</div>
<!--        <div><strong>Update Mail:&nbsp;</strong>{{currentItem.updateMail}} times</div>
        <div><strong>Removal Mail:&nbsp;</strong>{{currentItem.removalMail}} times</div>-->
        <div><strong>After Removal Mail:&nbsp;</strong>{{currentItem.afterRemovalMail}} times</div>
      </v-card-text>
    </v-card>
  </base-popup>
</template>

<script>
import BasePopup from "./BasePopup";
import Popup from "../mixins/Popup";
import mailTemplate from "../../json/mailTemplate.json"
import Invoice from "@/services/Invoice";
export default {
  name: "LinkPopup",
  mixins: [Popup],
  components: {BasePopup},
  data() {
    return {
      selectedItem: 0,
      mailTemplate: mailTemplate,
      details: [],
      headers: [
        {
          text: 'Site Link',
          value: 'site'
        },
        {
          text: 'Total',
          value: 'total',
          align: 'right'
        }
      ]
    }
  },
  computed: {
    getDetails() {
      return this.details;
    }
  },
  watch: {
    currentItem: {
      handler() {
        this.getInvoiceDetails();
      },
      deep: true
    }
  },
  methods: {
    closeFilesPopupHandler() {
      this.$emit('closePopupHandler');
    },
    liveLinkHandler(site) {
      window.open(site, '_blank');
    },
    getRefLink(refcode) {
      const api = process.env.VUE_APP_BASE_URL;
      return `${api}/payment?refno=${refcode}`;
    },
    getTitle(title) {
      return title.replaceAll('type', this.currentItem.billingType);
    },
   async getInvoiceDetails() {
      this.details = [];
      if (!this.currentItem.id) return;
      this.isOverlay = true;
      let {data} = await Invoice.invoiceDetails({id: this.currentItem.id});
      if(data) {
        this.details = data;
      }
      this.isOverlay = false;
    }
  }
}
</script>

<style lang="scss">
.link-text {
  color: #1976d2;
  padding: 3px 0;
  font-size: 12px;
}
.invoice-details .v-data-table__wrapper table tbody tr{
  vertical-align: bottom !important;
}
</style>